(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-sticky-add-to-cart"]) return;
  try {
    
  class KsStickyAtc extends HTMLElement {
    constructor () {
      super()

      this.variantSelector = this.querySelector('select[name="id"]')
      // Updated selectors for Debut theme
      this.mainVariantInput = document.querySelector('.product-form input[name="id"]') || 
                             document.querySelector('[data-product-form] input[name="id"]') ||
                             document.querySelector('form[action*="/cart/add"] input[name="id"]')

      this.handleVisibility()
      this.handleVariantChange()
      this.handleMainVariantChange()
    }

    handleVisibility () {
      // Updated selector for Debut theme
      const productForm = document.querySelector('.product-form') || 
                         document.querySelector('[data-product-form]') ||
                         document.querySelector('.product-single__form')
      
      if (!productForm) {
        console.warn('Product form not found for sticky ATC')
        return
      }

      const top = productForm.getBoundingClientRect().bottom + window.scrollY

      const handleScroll = () => {
        if (window.scrollY > top) {
          this.classList.add('show')
          document.body.style.paddingBottom = this.offsetHeight + 'px'
        } else {
          this.classList.remove('show')
          document.body.style.paddingBottom = '0'
        }
      }

      window.addEventListener('scroll', handleScroll)
      // Check immediately in case page is already scrolled
      handleScroll()
    }

    handleVariantChange () {
      if (!this.variantSelector) return

      this.variantSelector.addEventListener('change', () => {
        const selectedOption = this.variantSelector.querySelector('option:checked')
        const variantImg = selectedOption.getAttribute('data-img')
        const variantComparePrice = selectedOption.getAttribute('data-compare-price')
        const variantPrice = selectedOption.getAttribute('data-price')

        // Update images
        this.querySelectorAll('img').forEach(elem => {
          if (variantImg) {
            elem.src = variantImg
          }
        })
 
        // Update prices
        this.querySelectorAll('.ks-sticky-atc-price').forEach(elem => {
          if (variantComparePrice && variantComparePrice.length && variantComparePrice !== 'null') {
            elem.classList.add('price--on-sale')
            const regularElem = elem.querySelector('.price-item--regular')
            const saleElem = elem.querySelector('.price-item--sale')
            if (regularElem) regularElem.textContent = variantComparePrice
            if (saleElem) saleElem.textContent = variantPrice
          } else {
            elem.classList.remove('price--on-sale')
            const regularElem = elem.querySelector('.price-item--regular')
            if (regularElem) regularElem.textContent = variantPrice
          }
        })

        // Update buttons
        this.querySelectorAll('button[name="add"]').forEach(btn => {
          const btnText = btn.querySelector('span')
          if (selectedOption.disabled) {
            btn.disabled = true
            if (btnText) btnText.textContent = this.dataset.textSoldOut
          } else {
            btn.disabled = false
            const soldOutMsg = btn.querySelector('.sold-out-message')
            if (soldOutMsg) soldOutMsg.classList.add('hidden')
            if (btnText) btnText.textContent = this.dataset.textAddToCart
          }
        })

        // Sync with main form
        if (this.mainVariantInput) {
          this.mainVariantInput.value = this.variantSelector.value
          // Trigger change event on main form
          this.mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }))
        }
      })
    }

    handleMainVariantChange () {
      if (!this.mainVariantInput || !this.variantSelector) return

      // Listen for changes from the main product form
      this.mainVariantInput.addEventListener('change', () => {
        if (this.variantSelector.value !== this.mainVariantInput.value) {
          this.variantSelector.value = this.mainVariantInput.value
          this.variantSelector.dispatchEvent(new Event('change'))
        }
      })

      // Also listen for Debut theme specific events
      document.addEventListener('variant:change', (event) => {
        if (event.detail && event.detail.variant) {
          const variantId = event.detail.variant.id
          if (this.variantSelector.value !== variantId.toString()) {
            this.variantSelector.value = variantId.toString()
            this.variantSelector.dispatchEvent(new Event('change'))
          }
        }
      })
    }
  }
  
  if (customElements.get('ks-sticky-atc') === undefined) {
    customElements.define('ks-sticky-atc', KsStickyAtc)
  }

  } catch(e) { console.error(e); }
})();
})();
